// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '5473f54c882f46c75286d5a8da0ef17285b5afe6';
export const BUILD_NUMBER = '244';
export const BUILD_TIMESTAMP = '2026-09-17T07:55:01.571Z';
